import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import { Description } from './styles';

export function NotAnalyzedDescription(): JSX.Element {
	return (
		<Row align="middle" style={{ marginBottom: '1rem' }}>
			<Col span={5}>
				<Description>{I18n.get('Not applicable')}</Description>
			</Col>
		</Row>
	);
}
